import { configureStore } from '@reduxjs/toolkit'
import appReducer, { initialState as appInitialState } from './app/appSlice'
import testReducer from './test/testSlice'
import dashboardReducer from './dashboard/dashboardStore'
import roomTypeReducer from './dashboard/roomType/roomTypeSlice'
import completionRateReducer from './completionRate/completionRateStore'
import alertsReducer from './alerts/alertsStore'
import erpReducer from './erp/erpStore'
import orderReducer from './order/orderStore'
import ys7Reducer from './ys7/ys7Store'
import yingshiReducer from './yingshi/yingshiStore'
import sseReducer from './sse/sseSlice'
import surveillanceMessageReducer from './sse/surveillanceMessageSlice'
import componentsReducer from './components/componentsStore'
import useReducer from './use/useStore'
import tuinaReducer from './tuina/tuinaStore'
import { loadState } from '@/utils/localStorage'

// 从 localStorage 恢复状态
const savedState = loadState()

// 只恢复 app 状态，其他 slice 使用默认初始状态（避免旧数据残留）
// 剥离已废弃的 roles/resources，permissionCodes 与 initialState 合并
const preloadedState = savedState?.app ? (() => {
  const { roles, resources, ...restSavedApp } = savedState.app || {}
  return {
    app: {
      ...appInitialState,
      ...restSavedApp,
      javaToken: savedState.app?.javaToken || appInitialState.javaToken,
      permissionCodes: {
        ...appInitialState.permissionCodes,
        ...(savedState.app?.permissionCodes && typeof savedState.app.permissionCodes === 'object'
          ? savedState.app.permissionCodes
          : {})
      },
      // 冷启动必须重新拉 RBAC 后再信「已加载」：若沿用 localStorage 里 permissionCodesLoaded=true
      // 且 menuCodes 为空/过期，ClientDefaultRedirect 会在补拉完成前 resolve 成 /dashboard 并一直停留。
      permissionCodesLoaded: false,
      permissionCodesFetchFailed: false,
      // 刷新/关页时若曾卡在 pending，持久化里可能为 true；App.js 会因「拉取中」跳过 bootstrap，永无新请求。
      permissionCodesFetching: false
    }
  }
})() : undefined

export const store = configureStore({
  reducer: {
    app: appReducer,
    test: testReducer,
    dashboard: dashboardReducer,
    roomType: roomTypeReducer,
    completionRate: completionRateReducer,
    alerts: alertsReducer,
    erp: erpReducer,
    order: orderReducer,
    ys7: ys7Reducer,
    yingshi: yingshiReducer,
    sse: sseReducer,
    surveillanceMessage: surveillanceMessageReducer,
    components: componentsReducer,
    use: useReducer,
    tuina: tuinaReducer
  },
  preloadedState, // 恢复保存的状态
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }),
  devTools: process.env.NODE_ENV !== 'production'
})

// 暴露 store 到全局，供 ys7.js 等模块使用（避免循环依赖）
// 注意：必须在 store 创建完成后设置，避免在模块加载时产生循环依赖
if (typeof window !== 'undefined') {
  window.__REDUX_STORE__ = store
}

export default store